import { jsx as _jsx } from "react/jsx-runtime";
import { BrowserRouter } from 'react-router-dom';
import LocalizationContextProvider from '../../localization/LocalizationContext';
import { appContainer } from '../../app';
export var AppEntry = function (_a) {
    var children = _a.children, app = _a.app;
    appContainer.init(app);
    return (_jsx(BrowserRouter, { children: _jsx(LocalizationContextProvider, { children: children }) }));
};
export default AppEntry;
